import { range } from 'lodash';

export function truncatedRange(
  currentIndex: number,
  maxIndex: number,
  padding: number,
): number[] {
  const minIndex = 0;
  const desiredStart = currentIndex - padding;
  const clampedStart = Math.max(minIndex, desiredStart);
  const desiredEnd = currentIndex + padding;
  const clampedEnd = Math.min(maxIndex, desiredEnd);
  const start = Math.max(minIndex, clampedStart - (desiredEnd - clampedEnd));
  const end = Math.min(maxIndex, clampedEnd + (clampedStart - desiredStart));
  return range(start, end + 1);
}
